export const visit = (vm, at) => {
at({ "tr": { "conversationsVisitorUIAvailability": { "sameDay": "Bug\xFCn {{time}}'de d\xF6nece\u011Fiz", "nextDay": "Yar\u0131n {{time}}'de d\xF6nece\u011Fiz", "nextWeek": "{{dayOfWeek}} g\xFCn\xFC {{time}}'de d\xF6nece\u011Fiz" } } });
};